import script from "./adgift.vue?vue&type=script&setup=true&lang=js"
export * from "./adgift.vue?vue&type=script&setup=true&lang=js"

import "./adgift.vue?vue&type=style&index=0&id=7d1e970a&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1e970a"]])

export default __exports__